import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoGitlab = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 137 48"
    {...props}
  >
    <g clipPath="url(#Logo_Gitlab_svg__a)">
      <path
        fill="#888F9B"
        d="M99.049 14.052h-2.673v20.006h10.841v-2.485h-8.168zm18.487 16.497a4.6 4.6 0 0 1-3.324 1.395c-2.042 0-2.867-1.003-2.867-2.332 0-1.983 1.368-2.942 4.301-2.942.543 0 1.434.065 1.89.152zm-2.759-12.117a8.84 8.84 0 0 0-5.692 2.049l.956 1.656c1.086-.632 2.433-1.286 4.367-1.286 2.194 0 3.172 1.134 3.172 3.03v.98c-.435-.087-1.304-.152-1.869-.152-4.692 0-7.06 1.656-7.06 5.1 0 3.094 1.89 4.641 4.757 4.641 1.934 0 3.781-.894 4.411-2.332l.477 1.962h1.891V23.837c-.022-3.247-1.434-5.405-5.41-5.405m14.034 13.62c-.999 0-1.89-.13-2.563-.435v-9.24c.912-.763 2.042-1.308 3.476-1.308 2.585 0 3.584 1.83 3.584 4.795.022 4.206-1.608 6.189-4.497 6.189m1.13-13.62c-2.39 0-3.693 1.635-3.693 1.635v-6.015h-2.629v19.526c1.303.545 3.107.85 5.062.85 4.996 0 7.408-3.203 7.408-8.739 0-4.358-2.216-7.257-6.148-7.257m-60.047-2.2c2.368 0 3.91.784 4.91 1.59l1.151-2.005c-1.564-1.373-3.693-2.114-5.93-2.114-5.692 0-9.69 3.487-9.69 10.504 0 7.366 4.302 10.243 9.234 10.243a15.8 15.8 0 0 0 5.93-1.155l-.065-7.867v-2.506h-7.321v2.484h4.67l.066 5.971c-.608.305-1.673.545-3.107.545-3.954 0-6.604-2.506-6.604-7.758 0-5.34 2.737-7.933 6.756-7.933m18.857-2.18h-2.628v14.972c0 3.247 1.412 5.404 5.387 5.404.543 0 1.087-.043 1.608-.152v-2.354c-.37.065-.782.087-1.217.087-2.194 0-3.171-1.133-3.171-3.029v-7.998h4.388v-2.18H88.73zm-9.276 20.006h2.629V18.803h-2.63zm0-17.37h2.629v-2.636h-2.63z"
      />
      <path
        fill="#D74B3A"
        d="m24.425 46 8.777-27.066H15.648z"
      />
      <path
        fill="#F36F3C"
        d="m24.425 46-8.777-27.066H3.374z"
      />
      <path
        fill="#F3993F"
        d="M3.374 18.934.702 27.149c-.239.741.022 1.57.652 2.027l23.05 16.803z"
      />
      <path
        fill="#D74B3A"
        d="M3.374 18.933H15.67L10.369 2.632c-.26-.85-1.456-.85-1.716 0z"
      />
      <path
        fill="#F36F3C"
        d="m24.425 46 8.777-27.066h12.296z"
      />
      <path
        fill="#F3993F"
        d="m45.476 18.934 2.672 8.215a1.82 1.82 0 0 1-.651 2.027L24.447 45.98z"
      />
      <path
        fill="#D74B3A"
        d="M45.476 18.933H33.18l5.279-16.301c.282-.828 1.455-.828 1.716 0z"
      />
    </g>
    <defs>
      <clipPath id="Logo_Gitlab_svg__a">
        <path
          fill="#fff"
          d="M.615 0h136v48h-136z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoGitlab;
